import useInterval from "@rooks/use-interval";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

import axios from "../../../api/axios";

var request_updateTimelineData_safe = true;
var offset = new Date().getTimezoneOffset() / 60;
if (offset < 0) {
  offset *= -1;
}
offset = Math.floor(offset);

const AverageVelocity = ({ token }) => {
  const [deviceVelocity, setdeviceVelocity] = useState([]);
  const [deviceKeys, setDeviceKeys] = useState([]);

  const [loading, setLoading] = useState(true);

  // function updateTimelineData() {
  //   if (request_updateTimelineData_safe === false) {
  //     return;
  //   } else {
  //     request_updateTimelineData_safe = false;
  //   }
  //   axios
  //     .get(`/v1/realtime/velocity?token=${token}`)
  //     .then((res) => {
  //       let map = new Map();
  //       for (let i = 0; i < res.data.length; i++) {
  //         let data = res.data[i];
  //         // console.log(data);
  //         let time = new Date().getTime() - data.timestamp;
  //         if (time < 20000) {
  //           let velocity = res.data[i].velocity;
  //           velocity.filter((val) => val > 0);
  //           let val = velocity.reduce((a, b) => {
  //             return a + b;
  //           });
  //           val /= velocity.length;
  //           map.set(res.data[i]["sensor"], val);
  //         }
  //       }
  //       setDeviceKeys((prev) => [...map.keys()]);
  //       setdeviceVelocity((prev) => [...map.values()]);
  //       setLoading(false);
  //       // TODO: need to check if this if needed
  //       // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
  //       setLoading(false);
  //       // if (totalCountVehicles !== totalVehicles) {
  //       //   setTotalCountVehicles((prev) => totalVehicles);
  //       // }
  //       request_updateTimelineData_safe = true;
  //     })
  //     .catch((err) => {
  //       console.log(
  //         "error with get hour statistic inside today vehicles-> ",
  //         err
  //       );
  //     });
  // }
  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(`/v1/realtime/velocity/minutes?token=${token}&areas=null`, {
        withCredentials: true,
      })
      .then((res) => {
        let map = new Map();
        for (let i = 0; i < res.data.length; i++) {
          // console.log(data);
          let velocity = res.data[i].velocity;
          if (velocity) {
            map.set(res.data[i]["sensor"], velocity);
          } else {
            map.set(res.data[i]["sensor"], 0);
          }
          // console.log(velocity);
        }
        setDeviceKeys((prev) => [...map.keys()]);
        setdeviceVelocity((prev) => [...map.values()]);
        setLoading(false);
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        setLoading(false);
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }
  useEffect(() => {
    updateTimelineData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (!loading) updateTimelineData();
    },
    5000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 w-full h-full rounded-md overflow-hidden object-contain transition-all">
        <div className="w-72 h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
      </div>
    );
  }
  return (
    <div className="w-full h-full pt-2">
      <div className="grid grid-cols ">
        {deviceVelocity.length > 0 &&
          Array.from(deviceVelocity).map(
            (value, index) => (
              <div
                key={deviceKeys.at(index)}
                className={`
             text-center rounded-2xl  `}
              >
                <div
                  className="flex justify-center font-bold text-lg justify-items-center mx-1"
                  key={deviceKeys.at(index)}
                >
                  <div className="border-b-2 border-gray-400 border-opacity-20 shadow-sm  text-gray-600 ">
                    Real-Time Average Vehicle Speed
                  </div>
                  {/* {console.log(deviceKeys.at(index))} */}
                </div>
                <div className="md:w-5/6 md:ml-6 xl:ml-2 xl:mb-5  2xl:mb-5 2xl:mt-6  contents self-center">
                  <CircularProgressbarWithChildren
                    className="flex-wrap pt-14  mx-2 rounded-md "
                    key={deviceKeys.at(index)}
                    value={value.toFixed(2)}
                    maxValue={30}
                    circleRatio={0.75}
                    styles={buildStyles({
                      // Rotation of path and trail, in number of turns (0-1)
                      rotation: 1 / 2 + 1 / 8,

                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                      strokeLinecap: "butt",

                      // Text size
                      text: {
                        fill: "#0d6aff",
                        fontSize: "10px",
                      },

                      backgroundColor: "#61e8ae",

                      // How long animation takes to go from one percentage to another, in seconds
                      pathTransitionDuration: 0.2,

                      // Can specify path transition in more detail, or remove it entirely
                      // pathTransition: 'none',

                      // Colors
                      pathColor:
                        value < 5
                          ? `rgba(230, 25, 25, ${value.toFixed(2) * 5})`
                          : value < 10
                          ? `rgba(242, 235, 15, ${value.toFixed(2) * 7})`
                          : ` rgba(15, 242, 30, ${value.toFixed(2) * 10})`,
                      textColor: "#6193e8",
                      trailColor: "#bccee8",
                      position: "center",
                    })}
                  >
                    <div className="flex flex-col  text-xl mb-6  text-gray-600">
                      <strong className="text-xl">
                        {value.toFixed(2)} kmh{" "}
                      </strong>
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
              </div>
            ),
            [deviceVelocity, deviceKeys]
          )}
        {deviceVelocity.length === 0 && (
          <div
            className={`
         text-center rounded-2xl mx-3 `}
          >
            <div className="font-bold text-lg text-gray-600  ">
              No Sensor at Service
              {/* {console.log(deviceKeys.at(index))} */}
            </div>
            <div className="flex flex-col  self-center mx-3 pt-2">
              <CircularProgressbarWithChildren
                className="flex-wrap rounded-md "
                value={0}
                maxValue={30}
                circleRatio={0.75}
                styles={buildStyles({
                  // Rotation of path and trail, in number of turns (0-1)
                  rotation: 1 / 2 + 1 / 8,

                  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                  strokeLinecap: "butt",

                  // Text size
                  text: {
                    fill: "#0d6aff",
                    fontSize: "10px",
                  },

                  backgroundColor: "#61e8ae",

                  // How long animation takes to go from one percentage to another, in seconds
                  pathTransitionDuration: 0.2,

                  // Can specify path transition in more detail, or remove it entirely
                  // pathTransition: 'none',

                  textColor: "#6193e8",
                  trailColor: "#bccee8",
                  position: "center",
                })}
              >
                <div className="flex flex-col text-xl  xl:text-xl text-gray-600">
                  <strong className="text-xl">0 kmh </strong>
                </div>
              </CircularProgressbarWithChildren>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AverageVelocity;
